import { PlaybookTranscriptType } from 'UI/Components'

const fallbackTranscript = { segments: [], playbookId: '' }

export const fetchTranscript = async (url: string): Promise<PlaybookTranscriptType> => {
    try {
        const response = await fetch(url)
        const data = await response.text()
        return data ? JSON.parse(data) : fallbackTranscript
    } catch (e) {
        console.error(e)
        return fallbackTranscript
    }
}
